<div class="navigation-container"
     *ngIf="!isMobile && !popupMode && (builderHistoryService.builderStep|async) !== builderStep.SHOW_HERO && (!user || (!!user && (builderHistoryService.builderStep|async) !== builderStep.SHOW_FINALIZE))" [ngClass]="{'ds-disabled': popupMode
|| (builderHistoryService.builderStep|async) !== builderStep.SHOW_CANVAS || prefilledAi}"
     (click)="reset()">
  <i class="db-icon db-icon-ds-logo-black"></i>
</div>

<div *ngIf="[builderStep.SHOW_FINALIZE].includes(builderHistoryService.builderStep.value) && !isMobile && !user"
     class="create-ai-image-wrap">
  <div class="create-ai-image-1">
    <div class="create-ai-image">
      <img src="assets/images/ai/onboarding/ai-informative-light.svg" alt="">
    </div>
  </div>
  <div class="create-ai-image-2">
    <div class="create-ai-image">
      <img src="assets/images/ai/onboarding/ai-informative-light-full.svg" alt="">
    </div>
  </div>
</div>


<ng-container *ngIf="!isMobile">
  @if ([builderStep.CHOOSE_BUSINESS_TYPE].includes(builderHistoryService.builderStep.value)) {
    <div class="db-choose-website-wrap">
      <div class="db-image shrink {{isEcommerce && 'ecommerce'}}">
      </div>
    </div>
  } @else if ([builderStep.FILL_COMPANY_INFO].includes(builderHistoryService.builderStep.value) && fromVibeCoding) {
    <div class="db-left-side">
      <div>
        <i class="db-icon db-icon-ds-ai-generate fadeIn mb14"></i>
          <div class="db-header mb10" textSlideUp data-animate="slideUp1" [animationDuration]="500" [delay]="90" >
            Let’s start creating<br/>
            your website with AI
          </div>

        <div class="db-desc" textSlideUp data-animate="slideUp2"  [animationDuration]="400" [delay]="60">
          Answer a few questions and our AI will generate a personalized  website with tailored content and images.
        </div>
      </div>

    </div>
  }
  @else if ([builderStep.FILL_COMPANY_INFO].includes(builderHistoryService.builderStep.value) && !prefilledAi && !fromVibeCoding) {
    <div class="db-create-info">
      <div class="fade-up">

        <div class="db-example-label fade-up mb24">
          <div class="fade-label" [ngClass]="{'ecommerce': isEcommerce}">
            Example
          </div>
        </div>

        <div class="db-example-content">
          <ng-container
            *ngFor="let text of isEcommerce ? categoryTextsEcommerce : getTextsForCategory(params['business_category'].toString())">
            <div class="fade-text" [ngClass]="{'ecommerce': isEcommerce}" [innerHTML]="text | dbText"></div>
          </ng-container>
        </div>

      </div>
    </div>
  } @else if ([builderStep.PRODUCT_TYPE].includes(builderHistoryService.builderStep.value)) {
    <div class="db-create-products">

      <div class="marquee">
        <div class="marquee__content">
          <div class="text-row">Beauty Fashion Home Beauty Fashion Home Beauty Fashion Home</div>
          <div class="text-row">Beauty Fashion Home Beauty Fashion Home Beauty Fashion Home</div>
        </div>
        <div class="marquee__content">
          <div class="text-row">Pets Baby Toys Pets Baby Toys Pets Baby Toys</div>
          <div class="text-row">Pets Baby Toys Pets Baby Toys Pets Baby Toys</div>
        </div>

        <div class="marquee__content">
          <div class="text-row">Food Garden Furniture Food Garden Furniture</div>
          <div class="text-row">Food Garden Furniture Food Garden Furniture</div>
        </div>

        <div class="marquee__content">
          <div class="text-row">Fitness Tools Cameras Fitness Tools Cameras Fitness Tools Cameras Fitness Tools
            Cameras
          </div>
          <div class="text-row">Fitness Tools Cameras Fitness Tools Cameras Fitness Tools Cameras Fitness Tools
            Cameras
          </div>
        </div>
        <!-- Add more marquee__content divs as needed -->
      </div>

    </div>
  }
</ng-container>

@if (((builderHistoryService.builderStep|async) === builderStep.CHOOSE_BUSINESS_TYPE) && !isEcommerce && !prefilledAi
&& !fromVibeCoding) {
  <db-choose-business-type
    #chooseWebsite
    (companyTypeSelected)="setCompanyType($event)"
    (companyTypeSearchedList)="searchedCompanyTypeList = $event"
    [companyTypesForView]="searchedCompanyTypeList || companyTypesForView"
    [selectedCompanyType]="params?.business_type"
    [selectedBusinessCategory]="params?.business_category"
    [companyTypes]="companyTypes"
    [popupMode]="popupMode"
    [user]="user"
    [uniqueId]="uniqueId"
    [isMobile]="isMobile"
    (mobileNext)="onNextClick()"
    (back)="setDefault()"
    [hasEcommerceService]="!!userSubscription?.plan?.woocommerceService"
    (categoryType)="selectedCategoryType = $event"
  ></db-choose-business-type>
} @else if (((builderHistoryService.builderStep|async) === builderStep.CHOOSE_BUSINESS_TYPE) && isEcommerce
&& !prefilledAi && !fromVibeCoding) {
  <db-choose-store-type
    #chooseStore
    (companyTypeSelected)="setCompanyType($event)"
    (companyTypeSearchedList)="searchedCompanyTypeList = $event"
    [storeTypesForView]="searchedCompanyTypeList || storeTypesForView"
    [selectedCompanyType]="params?.business_type"
    [selectedBusinessCategory]="params?.business_category"
    [storeTypes]="storeTypes"
    [popupMode]="popupMode"
    [user]="user"
    [uniqueId]="uniqueId"
    [isMobile]="isMobile"
    (mobileNext)="onNextClick()"
    (back)="setDefault()"
    [hasEcommerceService]="!!userSubscription?.plan?.woocommerceService"
    (categoryType)="selectedCategoryType = $event"
  ></db-choose-store-type>
} @else if ((builderHistoryService.builderStep|async) === builderStep.FILL_COMPANY_INFO) {
  @if (prefilledAi) {
    <db-prefilled-company-info
      #prefilledInfo
      [data]="prefilledAiData" [user]="user"
      [uniqueId]="uniqueId"
      [domainId]="domainId"
    ></db-prefilled-company-info>
  } @else {
    <db-create-company-info
      #createInfo
      [fromVibeCoding]="fromVibeCoding"
      [formGroupData]="data[current]"
      [oldFormData]="params"
      [isEcommerce]="isEcommerce"
      [popupMode]="popupMode"
      [domainId]="domainId"
      [user]="user"
      [uniqueId]="uniqueId"
      (onMobileGenerate)="generateWebsite()"
      (back)="onBackClick()"
      [isBusinessType]="selectedCategoryType === 'basic'"
    ></db-create-company-info>
  }
} @else if ((builderHistoryService.builderStep|async) === builderStep.PRODUCT_TYPE) {
  <db-create-product-categories
    #productPage
    [formGroupData]="data[current]"
    [fromVibeCoding]="fromVibeCoding"
    [oldFormData]="params"
    [popupMode]="popupMode"
    [domainId]="domainId"
    [user]="user"
    [uniqueId]="uniqueId"
    (onMobileGenerate)="generateWebsite()"
    (back)="onBackClick()"
    [isBusinessType]="selectedCategoryType === 'basic'"
  ></db-create-product-categories>
} @else if ((builderHistoryService.builderStep|async) === builderStep.SHOW_DESIGN) {
  <db-outline-design
    #design
    [user]="user"
    [isEcommerce]="isEcommerce"
    [popupMode]="popupMode"></db-outline-design>
} @else if ((builderHistoryService.builderStep|async) === builderStep.SHOW_FINALIZE) {
  <db-outline-generation-finalize [user]="user"
                                  [popupMode]="popupMode">
  </db-outline-generation-finalize>
}

<db-outline-sitemap
  [class.hidden]="(prefilledAi && !isMobileAutoGenerate ? false : (builderHistoryService.builderStep|async) !== builderStep.SHOW_CANVAS)"
  [class.with-animation]="prefilledAi"
  [class.active]="(builderHistoryService.builderStep|async) === builderStep.SHOW_CANVAS"
  [class.popupMode]="popupMode"
  #sitemap
  [user]="user"
  [pageMetas]="pageMetas"
  (onGenerate)="generateWebsite()"
  (openMagicLink)="openMagicLink.emit($event)"
  [uniqueId]="uniqueId"
  [popupMode]="popupMode"
  [outline]="outline"
  [prefilledAi]="prefilledAi"
  [isMobile]="isMobile"
  [fontStyles]="fontStyles"
  [disableDraggingEvents]="vibeCodingFlow && (builderInteractionsService.generatePrefilledSiteLoading | async)"
  [tourStep]="tourStep">
</db-outline-sitemap>

<ng-container *ngIf="vibeCodingFlow">
  <div class="overlay" [class.active]="(builderInteractionsService.generatePrefilledSiteLoading | async)">
    <db-prefilled-generation-finalize
      *ngIf="(builderInteractionsService.generatePrefilledSiteLoading | async)"
      [user]="user"
      [uniqueId]="uniqueId"
      [isEcommerce]="isEcommerce">
    </db-prefilled-generation-finalize>
  </div>
</ng-container>

@if ((builderHistoryService.builderStep|async) === builderStep.SHOW_HERO && !vibeCodingFlow) {
  <db-outline-hero-generation [user]="user" [uniqueId]="uniqueId" [isEcommerce]="isEcommerce"
                              [popupMode]="popupMode"
                              (showPrefilledSignup)="onGenerate.emit()"
                              (onGenerate)="onGenerate.emit()"
  ></db-outline-hero-generation>
}
<a class="ds-btn-m ds-btn-outline item" *ngIf="!!this.user && popupMode && builderHistoryService.builderStep.value ===
  builderStep.SHOW_DESIGN"
   [ngClass]="{'back-generation-step': popupMode && builderHistoryService.builderStep.value ===
  builderStep.SHOW_DESIGN,
  'popup-back-btn': popupMode && [builderStep.SHOW_CANVAS].includes(builderHistoryService.builderStep.value),
  'hidden': (builderHistoryService.builderStep.value === builderStep.FILL_COMPANY_INFO && (fromVibeCoding || prefilledAi)) || ((builderHistoryService.builderStep.value) === builderStep.SHOW_CANVAS && prefilledAi)}"
   (click)="onBackClick()">
      <span>
        <i class="db-icon db-icon-ds-arrow-right-sharp"></i>
      </span>
</a>
<div
  *ngIf="(builderHistoryService.builderStep|async) !== builderStep.SHOW_HERO && (builderHistoryService.builderStep|async) !== builderStep.SHOW_FINALIZE && !((builderHistoryService.builderStep|async) == builderStep.FILL_COMPANY_INFO && prefilledAi) && !isMobile"
  [class.active]="(startAnimations$|async) && (builderInteractionsService.discoverBusinessDataReady | async)"
  [class.hidden]="(builderInteractionsService.generatePrefilledSiteLoading | async) || !(builderInteractionsService.discoverBusinessDataReady | async)"
  [class.popupMode]="popupMode"
  [class.with-animation]="(prefilledAi && (builderHistoryService.builderStep|async) !== builderStep.SHOW_DESIGN) || popupMode"
  class="db-actions-line">
  <a class="ds-btn-m ds-btn-outline item" [ngClass]="{'back-generation-step': popupMode && builderHistoryService.builderStep.value ===
  builderStep.CHOOSE_BUSINESS_TYPE,
  'hidden': !!user && ((popupMode && [builderStep.SHOW_CANVAS, builderStep.SHOW_DESIGN].includes(builderHistoryService.builderStep.value))
  || (builderHistoryService.builderStep.value === builderStep.FILL_COMPANY_INFO && (fromVibeCoding || prefilledAi)) || ((builderHistoryService.builderStep.value) === builderStep.SHOW_CANVAS && prefilledAi)),
  'db-hidden': !user && ((popupMode && [builderStep.SHOW_CANVAS, builderStep.SHOW_DESIGN].includes(builderHistoryService.builderStep.value))
  || (builderHistoryService.builderStep.value === builderStep.FILL_COMPANY_INFO && (fromVibeCoding || prefilledAi)) || ((builderHistoryService.builderStep.value) === builderStep.SHOW_CANVAS && prefilledAi))}"
     (click)="(builderHistoryService.builderStep.value) === builderStep.SHOW_CANVAS && !prefilledAi ? reset() : onBackClick()">
    <span>{{ 'text_back' | dbText }}</span>
  </a>
  <ul class="db-steps {{(builderHistoryService.builderStep | async)}} item" [ngClass]="{'ecom': isEcommerce, 'hidden': popupMode}">
    <li *ngFor="let step of getSteps(isEcommerce); let i = index"
        [ngClass]="{'active': isEcommerce ? ((prefilledAi ? ecomStepMapping.slice(1) : ecomStepMapping).indexOf(builderHistoryService.builderStep | async) >= i)
        : ((prefilledAi ? builderStepMapping.slice(1) : builderStepMapping).indexOf(builderHistoryService.builderStep | async) >= i)}">
      <span>{{ step }}</span>
    </li>
  </ul>
  <a class="ds-btn-m ds-btn-black item"
     *ngIf="(builderHistoryService.builderStep|async) !== builderStep.SHOW_DESIGN && (!!user || (!user && !((builderHistoryService.builderStep|async) === builderStep.SHOW_CANVAS
     && (vibeCodingFlow || fromVibeCoding))  ))"
     [ngClass]="{'ds-btn-disabled': (this.builderInteractionsService.disableNextButton|async)
   || (builderInteractionsService.loading|async)
   ||(builderInteractionsService.vibeCodingLoading|async)
   || (builderInteractionsService.generateDescriptionLoading | async),
   'ds-btn-max': popupMode,
  'ds-btn-loading': ((builderHistoryService.builderStep|async) === builderStep.SHOW_CANVAS && !(builderInteractionsService.secondaryPagesLoaded|async))}"
     (click)="onNextClick()">
    @if ((fromVibeCoding && (builderInteractionsService.loading|async) && ((builderHistoryService.builderStep|async) === builderStep.FILL_COMPANY_INFO)) ||
    ((builderHistoryService.builderStep|async) === builderStep.SHOW_CANVAS && (!(builderInteractionsService.secondaryPagesLoaded|async) || (builderInteractionsService.loading|async)))) {
      <db-loading-circular-spinner
        [color]="'monochrome'"
        [size]="'xs_small'"
        [newMode]="true">
      </db-loading-circular-spinner>
    } @else {
      <span>{{ 'text_next' | dbText}}</span>
    }
  </a>

  @if ((builderHistoryService.builderStep|async) === builderStep.SHOW_DESIGN
  || ((builderHistoryService.builderStep|async) === builderStep.SHOW_CANVAS && (vibeCodingFlow || fromVibeCoding) && !user)) {
    <a class="ds-btn-purple-blue ds-btn-m item"
      [class.ds-btn-max]="popupMode"
      [class.ds-btn-disabled]="((builderHistoryService.builderStep|async) === builderStep.SHOW_CANVAS && (!(builderInteractionsService.secondaryPagesLoaded|async) || (builderInteractionsService.loading|async)))"
       (click)="onClickGenerate()">
      @if (((builderHistoryService.builderStep|async) === builderStep.SHOW_CANVAS && (!(builderInteractionsService.secondaryPagesLoaded|async) || (builderInteractionsService.loading|async)))) {
        <db-loading-circular-spinner
          [color]="'monochrome'"
          [size]="'xs_small'"
          [newMode]="true">
        </db-loading-circular-spinner>
      } @else {
        <i class="db-icon db-icon-ds-ai mr8"></i>
        <span>{{ 'text_generate' | dbText }}</span>
      }
    </a>
  }

</div>


<!-- Lottie Animation -->
<div class="wave-animation"
     *ngIf="prefilledAi && !(builderInteractionsService.hidePrefilledAnimations | async) && ((builderHistoryService.builderStep|async) === builderStep.FILL_COMPANY_INFO || ((builderHistoryService.builderStep|async) === builderStep.SHOW_CANVAS) && !_triggerService.startSidebarAnimations.value)">
  <db-wave-background></db-wave-background>
</div>
